<app-module-header [title]="organization.organizationName + ' - ' + ('PRICING.PRICING' | transloco)"
[icon]="'payments'"></app-module-header>

@if (isLoading) {
  <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
}

<mat-tab-group syncTabsWithUrl>
  <mat-tab #discountChecksTab class="overflow-hidden" urlKey="discounts">
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">sell</mat-icon>
      {{ 'PRICING.DISCOUNTCHECK.DISCOUNTCHECKS' | transloco }}
    </ng-template>

    <mat-form-field appearance="fill" class="me-2">
      <mat-label>{{ 'PRICING.DISCOUNTCHECK.FILTER_DISCOUNTCHECKS' | transloco }}</mat-label>
      <mat-select [(value)]="selectedFilter" (selectionChange)="applyFilter()">
        <mat-option value="all">{{ 'PRICING.DISCOUNTCHECK.FILTER_OPTIONS.ALL' | transloco }}</mat-option>
        <mat-option value="active">{{ 'PRICING.DISCOUNTCHECK.FILTER_OPTIONS.ACTIVE' | transloco }}</mat-option>
        <mat-option value="expired">{{ 'PRICING.DISCOUNTCHECK.FILTER_OPTIONS.EXPIRED' | transloco }}</mat-option>
      </mat-select>
    </mat-form-field>

    <button [disabled]="isLoading" class="mb-2 me-2" mat-stroked-button color="primary"
      (click)="openEditPricingModal()">
      <mat-icon>add</mat-icon> {{ 'PRICING.DISCOUNTCHECK.CREATE_DISCOUNTCHECK' | transloco }}
    </button>

    <div>
      <div class="colheader">
        <mat-icon class="icon-bottom">sell</mat-icon>{{ 'PRICING.DISCOUNTCHECK.DISCOUNTCHECKS' | transloco }}:
        {{dataSourceDiscountCodes.data.length}}
        <!-- <mat-icon class="icon-bottom" [ngStyle]="{color:totalArrivalPickups > 0?'green':'black'}">emoji_people</mat-icon>{{totalArrivalPickups}} - {{totalArrivalPersons}} -->
      </div>
      <div class="overflow-auto">
        <table mat-table matSort
          [dataSource]="dataSourceDiscountCodes.data.length > 0 ? dataSourceDiscountCodes : emptyData"
          #sortCheckIn="matSort" class="mat-elevation-z8">

          <ng-container matColumnDef="discountCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.DISCOUNTCODE' | transloco }}
            </th>
            <td mat-cell *matCellDef="let order">{{order.discountCode}}</td>
          </ng-container>

          <ng-container matColumnDef="bundleName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.BUNDLENAME' | transloco }}
            </th>
            <td mat-cell *matCellDef="let order">{{order.bundleName}}</td>
          </ng-container>

          <ng-container matColumnDef="discountPercent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.DISCOUNT_PERCENT_SYMBOL' |
            transloco }}</th>
            <td mat-cell *matCellDef="let order">{{order.discountPercent}}</td>
          </ng-container>

          <ng-container matColumnDef="discountAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.AMOUNT' | transloco }}</th>
            <td mat-cell *matCellDef="let order">{{order.discountAmount}}</td>
          </ng-container>

          <ng-container matColumnDef="validFrom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.VALIDFROM' | transloco }}
            </th>
            <td mat-cell *matCellDef="let order">{{order.validFrom | date:'yyyy-MM-dd HH:mm'}}</td>
          </ng-container>

          <ng-container matColumnDef="validTo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.VALIDTO' | transloco }}</th>
            <td mat-cell *matCellDef="let order">{{order.validTo | date:'yyyy-MM-dd HH:mm'}}</td>
          </ng-container>

          <ng-container matColumnDef="parkingName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.PARKING' | transloco }}</th>
            <td mat-cell *matCellDef="let order">{{order.parkingName}}</td>
          </ng-container>

          <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.CREATED' | transloco }}</th>
            <td mat-cell *matCellDef="let order">{{order.created | date:'yyyy-MM-dd HH:mm'}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.STATUS' | transloco }}</th>
            <td mat-cell *matCellDef="let order">
              @if (order.status) {
                <app-status-badge [color]="getStatusColor(order.status)"
                [text]="order.status"></app-status-badge>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="discountTypeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'PRICING.DISCOUNTCHECK.DISCOUNT_TYPE' | transloco
            }}</th>
            <td mat-cell *matCellDef="let discount">
              @if (typeof discount?.discountTypeName === 'string') {
                {{ discount?.discountTypeName }}
              }
              @if (typeof discount?.discountTypeName === 'object') {
                @for (typeName of discount?.discountTypeName; track typeName) {
                  <mat-chip>{{ typeName }}</mat-chip>
                }
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="empty-row">
            <td mat-cell class="no-data-cell" *matCellDef="let element">{{ 'ERROR.NO_DATA' | transloco }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsCheckIn"></tr>
          <tr mat-row
            *matRowDef="let row; columns: dataSourceDiscountCodes.data.length > 0 ? displayedColumnsCheckIn : ['empty-row'];"
            (click)="openEditPricingModal(row)" class="clickable" [ngClass]="{'delayed': row.status === 'Delayed'}">
          </tr>
        </table>
      </div>
    </div>

  </mat-tab>

  <mat-tab #additonalServicesTab urlKey="additional-services">
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">add_shopping_cart</mat-icon>
      {{ 'PRICING.ADDITIONAL_SERVICES.ADDITIONAL_SERVICES' | transloco }}
    </ng-template>

    <button [disabled]="isLoading" class="my-3" mat-stroked-button color="primary"
      (click)="openEditAdditionalServiceModal()">
      <mat-icon>add</mat-icon> {{ 'PRICING.ADDITIONAL_SERVICES.CREATE_ADDITIONAL_SERVICES' | transloco }}
    </button>

    <app-additional-services-list [additionalServicesInput]="organizationAdditionalServices()"
    [organization]="organization"></app-additional-services-list>
  </mat-tab>

  <mat-tab #parkingPricingTab urlKey="parking">
    <ng-template mat-tab-label>
      <mat-icon class="example-tab-icon">local_parking</mat-icon>
      {{ 'PARKING_PRICING.TITLE' | transloco }}
    </ng-template>

    <div class="d-flex align-items-center flex-wrap form-fields w-auto">
      <mat-form-field class="me-2 " appearance="fill">
        <mat-label>{{ 'PARKING_PRICING.PARKINGS' | transloco }}</mat-label>
        <mat-select [(value)]="parkingPricingId" (selectionChange)="changeParking($event.value)">
          @for (parking of organization.config.parkings; track parking) {
            <mat-option [value]="parking.parkingId">
              {{parking.parkingName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <!--dropdown to multi select product types -->
      <!-- <div class=""> -->
      <!-- <label class="filter-label">{{ 'PARKING_PRICING.PARKINGS' | transloco }}</label> -->
      <mat-form-field class="me-2 multiple-select" appearance="fill">
        <!-- <mat-label>{{ 'PARKING_PRICING.PRODUCT_TYPE' | transloco }}</mat-label> -->
        <mat-select [placeholder]="'PARKING_PRICING.PRODUCT_TYPE' | transloco" multiple [(value)]="productTypeIds"
          (selectionChange)="changeProductType($event.value)" [disabled]="isLoading">
          @for (productType of productTypes; track productType) {
            <mat-option [value]="productType.value">
              {{productType.name | translateAttribute}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    <!-- </div> -->

    <!-- <button [disabled]="isLoading" class="my-3" mat-stroked-button color="primary" (click)="openEditParkingPricingModal()" >
    <mat-icon>add</mat-icon> {{ 'PARKING_PRICING.FORM.CREATE_PARKING_PRICING' | transloco }}
  </button> -->

  <button [disabled]="isLoading" class="mb-2 me-2" mat-stroked-button color="primary"
    (click)="openBulkUpdateParkingPricingModal()">
    <mat-icon>edit</mat-icon> {{ 'PARKING_PRICING.FORM.BULK_UPDATE_PARKING_PRICING' | transloco }}
  </button>
</div>


<app-parking-pricing-list [parkingPricingListInput]="organizationParkingPrices()" [productTypes]="productTypes"
[organization]="organization"></app-parking-pricing-list>
</mat-tab>
</mat-tab-group>